import React, { Component } from "react"
import Mutation from "./Mutation"
import PropTypes from "prop-types"

export default function withMutation() {
  return TargetComponent => {
    class WrappedComponent extends Component {
      static propTypes = {
        mutation: PropTypes.instanceOf(Mutation),
      }

      static displayName = `WithMutation(${TargetComponent.name})`
      static contextTypes = {
        mutation: PropTypes.instanceOf(Mutation).isRequired,
      }

      render() {
        const { mutation: mutationProp } = this.props
        const { mutation } = this.context

        return <TargetComponent mutation={mutationProp || mutation} {...this.props} />
      }
    }

    return WrappedComponent
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/lib/store/Mutation/withMutation.js